import React, { Fragment, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  withStyles,
} from "@material-ui/core";
import GetApp from "@material-ui/icons/GetApp";
import Skeleton from "@material-ui/lab/Skeleton";
import * as d3 from "d3";
import HoverableIcon from "../../components/Buttons/HoverableIcon ";
import { replaceDynamicValueLabel } from "../../util/utils";
import Tooltip from "@material-ui/core/Tooltip";
import DrilldownByStageTable from "./DrilldownByStageTable";
import { store } from "../../util/store";
import ReusableAgGrid from "../../components/AgGrid/AgGrid";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "rgb(255,255,255,0.8)",
    color: "black",
    fontFamily: "roboto",
    fontSize: theme.typography.pxToRem(14),
    borderRadius: "1rem",
    padding: "0px",
    boxShadow: "0 0.1rem 0.1rem 0",
    marginTop: "0.4rem",
  },
}))(Tooltip);

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
  headerCell: {
    border: "0.5px solid lightgrey",
    fontWeight: 600,
    padding: "6px 12px 6px 12px",
  },
  tableSpacer: {
    margin: "1rem",
    marginTop: "0rem",
  },
}));

const compareOultiers = (data1, data2) => {
  const arr = data1.map((item) => {
    const item2 = data2.find((i2) => i2.OppName === item.OppName);
    return item2
      ? { ...item, ...item2 }
      : {
          ...item,
          ML_Expected_ACV: "Outlier Opp.",
          ML_Final_Probability_Score: "Outlier Opp.",
        };
  });

  return arr;
};

const DrilldownSLDv2 = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  console.log("DrilldownSLD", props);
  const classes = useStyle();

  const state = store.getState();
  const Currency_Symbol = state.app.user.Currency;

  //projected yield toottip
  const projectedYieldTooltip = (
    <>
      {Array(1)
        .fill()
        .map((item) => (
          <>
            <div
              style={{
                borderTop: "solid #4471C4",
                borderRadius: "0.3rem",
                padding: "0px",
                margin: 0,
                borderWidth: "0.3rem",
              }}
            >
              <div className="container">
                <Typography
                  style={{ padding: "0.1rem" }}
                  className="heading-style"
                >{`SkyGeni Projected Yield from opps. in ${props.header}`}</Typography>
              </div>
            </div>
          </>
        ))}
    </>
  );

  //projected attainment tooltip
  const projectedAttainmentTooltip = (
    <>
      {Array(1)
        .fill()
        .map((item) => (
          <>
            <div
              style={{
                borderTop: "solid #4471C4",
                borderRadius: "0.3rem",
                padding: "0px",
                margin: 0,
                borderWidth: "0.3rem",
              }}
            >
              <div className="container">
                <Typography
                  style={{ padding: "0.1rem" }}
                  className="heading-style"
                >{`Won + SkyGeni Projected Yield from opps. in ${props.header}`}</Typography>
              </div>
            </div>
          </>
        ))}
    </>
  );

  let acvLabel = props.acvName ? `${props.acvName}:` : "ACV";
  if (props.Value_Label) {
    acvLabel = replaceDynamicValueLabel(acvLabel, props.Value_Label);
  }

  const convertedData =
    props.body &&
    (props.toggleValue === true
      ? compareOultiers(
          props.body.opportunities,
          props.body.message.opportunities[3]
        )
      : props.body.opportunities);

  const onCellClicked = (e) =>
    props.handleSecondLevelDrilldown("drilldownOppId", e.data.Opp_ID);

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  return (
    <Grid
      container
      className={classes.root}
      data-test={props.type ? `drilldown-${props.type}` : "drilldown"}
    >
      {props.body ? (
        <React.Fragment>
          {props.body.message.dataByStage ? (
            <Grid
              container
              justify="space-between"
              className={classes.titleContainer}
              xs={12}
            >
              {props.showLowMidHigh && props.pipeline && (
                <>
                  <Grid
                    item
                    container
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <Grid
                      item
                      sm={3}
                      lg={props.body.message.dataByStage ? 2 : 3}
                      style={{ padding: "1rem", paddingLeft: "0rem" }}
                    >
                      <TableContainer
                        className={classes.mainTable}
                        style={{ width: "95%" }}
                      >
                        <Table
                          size="small"
                          aria-label="html table"
                          style={{ tableLayout: "auto", width: "100%" }}
                          data-test="Qualified-Pipeline"
                        >
                          <TableBody>
                            <TableRow>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={2}
                                style={{
                                  background: "#4471c4",
                                  color: "white",
                                }}
                              >
                                Qualified Pipeline
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                # of Opps
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                {`${acvLabel}`}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="count"
                              >
                                {d3.format(",")(props.body.count_acv[0].count)}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="acv"
                              >
                                {`${Currency_Symbol}`}
                                {d3.format(",")(
                                  Math.round(
                                    props.body.count_acv[0].acv
                                  ).toString()
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>

                    <Grid
                      item
                      sm={5}
                      md={4}
                      lg={props.body.message.dataByStage ? 3 : 4}
                      style={{ padding: "1rem", paddingLeft: "0rem" }}
                    >
                      <TableContainer
                        className={classes.mainTable}
                        style={{ width: "95%" }}
                      >
                        <Table
                          size="small"
                          aria-label="html table"
                          style={{ tableLayout: "auto", width: "100%" }}
                          data-test="Projected-Yield"
                        >
                          <TableBody>
                            <TableRow>
                              <HtmlTooltip title={projectedYieldTooltip}>
                                <TableCell
                                  align="center"
                                  className={classes.headerCell}
                                  colSpan={3}
                                  style={{
                                    background: "#4471c4",
                                    color: "white",
                                  }}
                                >
                                  Projected Yield
                                </TableCell>
                              </HtmlTooltip>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                Low
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                Mid
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                High
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="low"
                              >
                                {`${Currency_Symbol}${d3.format(",")(
                                  Math.round(
                                    props.body.message.expectedYield.low
                                  ).toString()
                                )}`}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="mid"
                              >
                                {`${Currency_Symbol}${d3.format(",")(
                                  Math.round(
                                    props.body.message.expectedYield.mid
                                  ).toString()
                                )}`}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="high"
                              >
                                {`${Currency_Symbol}${d3.format(",")(
                                  Math.round(
                                    props.body.message.expectedYield.high
                                  ).toString()
                                )}`}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>

                    <Grid
                      item
                      sm={4}
                      md={4}
                      lg={props.body.message.dataByStage ? 3 : 4}
                      style={{ padding: "1rem", paddingLeft: "0rem" }}
                    >
                      <TableContainer
                        className={classes.mainTable}
                        style={{ width: "95%" }}
                      >
                        <Table
                          size="small"
                          aria-label="html table"
                          style={{ tableLayout: "auto", width: "100%" }}
                          data-test="Projected-Attainment"
                        >
                          <TableBody>
                            <TableRow>
                              <HtmlTooltip title={projectedAttainmentTooltip}>
                                <TableCell
                                  align="center"
                                  className={classes.headerCell}
                                  colSpan={3}
                                  style={{
                                    background: "#4471c4",
                                    color: "white",
                                  }}
                                >
                                  Projected Attainment
                                </TableCell>
                              </HtmlTooltip>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                Low
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                Mid
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.headerCell}
                                colSpan={1}
                              >
                                High
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="projected-low"
                              >
                                {`${Currency_Symbol}${d3.format(",")(
                                  Math.round(
                                    props.pipeline.projectedAttainmentLow
                                  ).toString()
                                )}`}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="projected-mid"
                              >
                                {`${Currency_Symbol}${d3.format(",")(
                                  Math.round(
                                    props.pipeline.projectedAttainmentMid
                                  ).toString()
                                )}`}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.headerCell}
                                colSpan={1}
                                data-test="projected-high"
                              >
                                {`${Currency_Symbol}${d3.format(",")(
                                  Math.round(
                                    props.pipeline.projectedAttainmentHigh
                                  ).toString()
                                )}`}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>

                    {props.body.message.dataByStage && (
                      <Grid
                        item
                        xs={5}
                        sm={6}
                        lg={4}
                        style={{ padding: "1rem", paddingLeft: "0rem" }}
                      >
                        <DrilldownByStageTable
                          data={props.body.message.dataByStage}
                          cols={props.body.message.openStages}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Grid
                    item
                    container
                    direction="column"
                    xs={12}
                    justifyContent="flex-end"
                    alignItems="flex-end"
                  >
                    <Grid item style={{ paddingBottom: "1rem" }}>
                      <button style={{ border: "none" }} onClick={handleExport}>
                        <HoverableIcon />
                      </button>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          ) : (
            <Grid
              container
              justifyContent="space-betweeen"
              className={classes.titleContainer}
              xs={12}
            >
              <Grid
                item
                container
                xs={12}
                justifyContent="flex-start"
                alignItems="flex-end"
              >
                {props.showLowMidHigh ? (
                  props.pipeline ? (
                    <>
                      <Grid item container xs={12}>
                        <Grid
                          item
                          sm={3}
                          lg={3}
                          className={classes.tableSpacer}
                          style={{ marginLeft: "0rem" }}
                        >
                          <TableContainer
                            className={classes.mainTable}
                            style={{ width: "95%" }}
                          >
                            <Table
                              size="small"
                              aria-label="html table"
                              style={{ tableLayout: "auto", width: "100%" }}
                              data-test="Qualified-Pipeline"
                            >
                              <TableBody>
                                <TableRow>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={2}
                                    style={
                                      2 % 2 === 0
                                        ? {
                                            background: "#4471c4",
                                            color: "white",
                                          }
                                        : {
                                            background: "#5b9bd5",
                                            color: "white",
                                          }
                                    }
                                  >
                                    Qualified Pipeline
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    # of Opps
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    {/* ACV */}
                                    {`${acvLabel}`}
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="count"
                                  >
                                    {d3.format(",")(
                                      props.body.count_acv[0].count
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="acv"
                                  >
                                    {Currency_Symbol}
                                    {d3.format(",")(
                                      Math.round(
                                        props.body.count_acv[0].acv
                                      ).toString()
                                    )}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>

                        <Grid
                          item
                          sm={5}
                          md={4}
                          lg={4}
                          className={classes.tableSpacer}
                        >
                          <TableContainer
                            className={classes.mainTable}
                            style={{ width: "95%" }}
                          >
                            <Table
                              size="small"
                              aria-label="html table"
                              style={{ tableLayout: "auto", width: "100%" }}
                              data-test="Projected-Yield"
                            >
                              <TableBody>
                                <TableRow>
                                  <HtmlTooltip title={projectedYieldTooltip}>
                                    <TableCell
                                      align="center"
                                      className={classes.headerCell}
                                      colSpan={3}
                                      style={
                                        2 % 2 === 0
                                          ? {
                                              background: "#4471c4",
                                              color: "white",
                                            }
                                          : {
                                              background: "#5b9bd5",
                                              color: "white",
                                            }
                                      }
                                    >
                                      Projected Yield
                                    </TableCell>
                                  </HtmlTooltip>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    Low
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    Mid
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    High
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="low"
                                  >{`${Currency_Symbol}${d3.format(",")(
                                    Math.round(
                                      props.body.message.expectedYield.low
                                    ).toString()
                                  )}`}</TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="mid"
                                  >{`${Currency_Symbol}${d3.format(",")(
                                    Math.round(
                                      props.body.message.expectedYield.mid
                                    ).toString()
                                  )}`}</TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="high"
                                  >{`${Currency_Symbol}${d3.format(",")(
                                    Math.round(
                                      props.body.message.expectedYield.high
                                    ).toString()
                                  )}`}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>

                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={4}
                          className={classes.tableSpacer}
                        >
                          <TableContainer
                            className={classes.mainTable}
                            style={{ width: "95%" }}
                          >
                            <Table
                              size="small"
                              aria-label="html table"
                              style={{ tableLayout: "auto", width: "100%" }}
                              data-test="Projected-Attainment"
                            >
                              <TableBody>
                                <TableRow>
                                  <HtmlTooltip
                                    title={projectedAttainmentTooltip}
                                  >
                                    <TableCell
                                      align="center"
                                      className={classes.headerCell}
                                      colSpan={3}
                                      style={
                                        2 % 2 === 0
                                          ? {
                                              background: "#4471c4",
                                              color: "white",
                                            }
                                          : {
                                              background: "#5b9bd5",
                                              color: "white",
                                            }
                                      }
                                    >
                                      Projected Attainment
                                    </TableCell>
                                  </HtmlTooltip>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    Low
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    Mid
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.headerCell}
                                    colSpan={1}
                                  >
                                    High
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="projected-low"
                                  >{`${Currency_Symbol}${d3.format(",")(
                                    Math.round(
                                      props.pipeline.projectedAttainmentLow
                                    ).toString()
                                  )}`}</TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="projected-mid"
                                  >{`${Currency_Symbol}${d3.format(",")(
                                    Math.round(
                                      props.pipeline.projectedAttainmentMid
                                    ).toString()
                                  )}`}</TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.headerCell}
                                    colSpan={1}
                                    data-test="projected-high"
                                  >{`${Currency_Symbol}${d3.format(",")(
                                    Math.round(
                                      props.pipeline.projectedAttainmentHigh
                                    ).toString()
                                  )}`}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>

                      {/* <Typography variant="body1" style={{ fontWeight: '600' }}>Number of opportunities: <span data-test='count'>{d3.format(",")(props.body.count_acv[0].count)}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ACV: $ <span data-test='acv'>{d3.format(",")(Math.round(props.body.count_acv[0].acv).toString())}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Expected Yield &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Low: $ <span data-test='low'>{d3.format(",")(Math.round(props.body.message.expectedYield.low).toString())}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mid: $ <span data-test='mid'>{d3.format(",")(Math.round(props.body.message.expectedYield.mid).toString())}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; High: $ <span data-test='high'>{d3.format(",")(Math.round(props.body.message.expectedYield.high).toString())}</span>
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Proj. Attain. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Low: $ <span data-test='proj-low'>{d3.format(",")(Math.round(props.pipeline.projectedAttainmentLow).toString())}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mid: $ <span data-test='mid'>{d3.format(",")(Math.round(props.pipeline.projectedAttainmentMid).toString())}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; High: $ <span data-test='high'>{d3.format(",")(Math.round(props.pipeline.projectedAttainmentHigh).toString())}</span>
                         </Typography>            */}
                    </>
                  ) : (
                    <Typography variant="body1" style={{ fontWeight: "600" }}>
                      Number of opportunities:{" "}
                      <span data-test="count">
                        {d3.format(",")(props.body.count_acv[0].count)}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      {`${acvLabel}: ${Currency_Symbol}`}{" "}
                      <span data-test="acv">
                        {d3.format(",")(
                          Math.round(props.body.count_acv[0].acv).toString()
                        )}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Expected Yield &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      Low: {`${Currency_Symbol}`}{" "}
                      <span data-test="low">
                        {d3.format(",")(
                          Math.round(
                            props.body.message.expectedYield.low
                          ).toString()
                        )}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mid:{" "}
                      {`${Currency_Symbol}`}{" "}
                      <span data-test="mid">
                        {d3.format(",")(
                          Math.round(
                            props.body.message.expectedYield.mid
                          ).toString()
                        )}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; High:{" "}
                      {`${Currency_Symbol}`}{" "}
                      <span data-test="high">
                        {d3.format(",")(
                          Math.round(
                            props.body.message.expectedYield.high
                          ).toString()
                        )}
                      </span>
                    </Typography>
                  )
                ) : (
                  <Typography variant="body1" style={{ fontWeight: "600" }}>
                    Number of opportunities:{" "}
                    <span data-test="count">
                      {d3.format(",")(props.body.count_acv[0].count)}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    {`${acvLabel}: ${Currency_Symbol}`}{" "}
                    <span data-test="acv">
                      {d3.format(",")(
                        Math.round(props.body.count_acv[0].acv).toString()
                      )}
                    </span>
                  </Typography>
                )}
              </Grid>
              <Grid
                direction="column"
                item
                container
                xs={12}
                justifyContent="flex-end"
                alignItems="flex-end"
                alignContent="flex-end"
              >
                <Grid
                  item
                  justifyContent="flex-end"
                  style={{ paddingBottom: "1rem" }}
                >
                  <button style={{ border: "none" }} onClick={handleExport}>
                    <HoverableIcon />
                  </button>
                </Grid>
              </Grid>
            </Grid>
          )}

          <ReusableAgGrid
            rowData={convertedData}
            columnConfig={props.body.columns}
            onCellClicked={props.showSLD ? onCellClicked : null}
            isExportable={true}
            header={props.header}
            rawColumnDataForExport={props.body.columns}
            exportTrigger={exportTrigger}
          />
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default DrilldownSLDv2;
